<div class="grid grid-cols-1 sm:grid-rows-6rem-auto-auto h-screen">
    <app-private-header class=""></app-private-header>
    <div class="grid grid-cols-1 sm:grid-cols-2 bg-gradient-b-light-gray">
        <div class="sm:row-span-1 p-6 sm:p-16 splash ">
            <app-tour-splash></app-tour-splash>
            <div class="hidden sm:flex w-full justify-center">
                <app-testimonial></app-testimonial>
            </div>
        </div>
        <div class="bg-white sm:bg-gradient-b-gray-white p-6 sm:p-16">
            <router-outlet></router-outlet>
        </div>
        <div class="sm:hidden flex w-full justify-center border-t border-gray-400">
            <app-testimonial></app-testimonial>
        </div>
    </div>
    <div class="flex flex-shrink-0 items-center justify-center bg-true-blue">
        <app-footer class="w-full text-white"></app-footer>
    </div>
</div>